export default {
  logistics: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Almacén y logística',
    hero: {
      eyebrow: 'Almacén y logística',
      title: 'Vigilancia de grandes superficies para logística y almacenes',
      lead: 'Gran angular, PTZ y visión nocturna: cubrimos grandes naves y exteriores con pocas cámaras bien ubicadas.',
    },
    areas: {
      title: 'Zonas de vigilancia en almacén y logística',
      lead: 'De la entrada al embalaje: estructuramos su vigilancia según el flujo de mercancías, sin huecos.',
      items: {
        '0': { title: 'Entrada y salida', desc: 'Cada vehículo que cruza su terreno se capta, con matrícula y sello de tiempo para documentación completa.' },
        '1': { title: 'Zona de entrega', desc: 'La llegada y recogida de mercancía son momentos sensibles. Las cámaras documentan cada movimiento en el muelle.' },
        '2': { title: 'Estanterías', desc: 'Las naves grandes necesitan grandes soluciones. Las cámaras PTZ barren los pasillos y acercan al palé si hace falta.' },
        '3': { title: 'Preparación de pedidos', desc: 'Embalaje y preparación implican movimiento. Las cámaras de visión general aclaran reclamaciones.' },
        '4': { title: 'Exterior y patio', desc: 'El perímetro es la primera línea de defensa. Cámaras resistentes vigilan vallas, puertas y vehículos.' },
        '5': { title: 'Oficina y administración', desc: 'La zona administrativa también necesita protección, para objetos de valor, documentos y accesos sensibles.' },
      },
    },
    coverage: {
      eyebrow: 'Grandes superficies a la vista',
      title: 'Una cámara, gran efecto',
      lead: 'En los almacenes cuenta la visión general. En vez de muchas cámaras sueltas, usamos tecnología que cubre grandes áreas de forma inteligente.',
      items: {
        '0': { title: 'Cámaras PTZ', desc: 'Girar, inclinar, acercar: una cámara cubre grandes áreas y da detalles cuando se necesita.' },
        '1': { title: 'Visión gran angular', desc: 'Para secciones de nave y exteriores: cámaras gran angular compactas captan grandes zonas en una imagen.' },
        '2': { title: 'Visión diurna y nocturna', desc: 'Infrarrojos y sensores muy sensibles dan imágenes útiles incluso en la oscuridad, todo el día.' },
      },
    },
    roundClock: {
      eyebrow: 'Todo el día',
      title: 'Grabación que nunca duerme',
      lead: 'El tráfico de mercancías no para de noche. Su sistema graba todo el día y hace los eventos localizables al instante.',
      list: {
        '0': 'Grabación 24/7 en grabador local con plazo definido',
        '1': 'Grabación por eventos ahorra espacio y facilita la búsqueda',
        '2': 'Reenvío de alarmas a personas definidas ante movimiento en zonas restringidas',
        '3': 'Mantenimiento regular de SSG Care para disponibilidad duradera',
        '4': 'Ampliable con más cámaras y otras ubicaciones',
      },
      note: 'Nota: el plazo de conservación debe adaptarse a requisitos operativos y legales. Le asesoramos al respecto.',
    },
    cta: {
      title: 'Su logística, documentada sin huecos',
      lead: 'Analizamos los flujos de mercancías y los puntos de riesgo, y planificamos un sistema acorde a su estructura.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Descubrir SSG Care',
    },
  },
};